import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import amplitude from "../utils/amplitude";
import { motion } from "framer-motion";

export default function LoadingScreen () {
  const navigate = useNavigate();

  useEffect(() => {
    // Установка CSS переменной --vh для корректной высоты экрана
    function setVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    setVh();
    window.addEventListener('resize', setVh);

    // Amplitude и таймер перехода
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Started', {
        option: "loading"
      });
      amplitude.track('Session Start', { platform: 'web' });
    }
    const timer = setTimeout(() => {
      navigate("/quiz1");
    }, 2000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', setVh);
    };
  }, [navigate]);

  return (
    <div
      className="max-w-[450px] w-full mx-auto p-4 text-center font-sans bg-white flex flex-col justify-between border rounded-lg shadow-md"
      style={{ minHeight: 'calc(var(--vh, 1vh) * 100)' }}
    >
      {/* Заголовок */}
      <div className="pt-4">
        <h1 className="text-lg md:text-xl font-semibold">
          See how quickly you can achieve <br />
          your skincare goals with Solvi
        </h1>
      </div>

      {/* Изображение */}
      <div className="my-6">
        <div className="relative w-72 h-72 mx-auto">
          {/* Анимируемый розовый фон под изображением */}
          <div
            className="absolute inset-0 rounded-full bg-pink-400 opacity-50 animate-pulsePink z-0"
          ></div>

          {/* Круглая рамка и картинка поверх */}
          <div
            className="relative z-10 rounded-full p-6 transform scale-105"
            style={{ border: "3px solid #ec4899" }}
          >
            <div className="w-full h-full rounded-full p-2 overflow-hidden">
              <img
                src="/loadingImg.png"
                alt="Skincare"
                className="object-cover w-full h-full rounded-full"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Лоадер и текст */}
      <div className="mb-6">
        <p className="font-medium text-md text-gray-700 mb-2">
          Please don't close this page
        </p>
        <div className="w-3/4 h-2 bg-gray-200 rounded-full mx-auto overflow-hidden">
          <motion.div 
            className="bg-pinkCustom h-full rounded-full"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ 
              duration: 2,
              ease: "easeInOut"
            }}
          />
        </div>
        <p className="text-sm text-gray-600 mt-2">
          Analyzing your skincare profile
        </p>
      </div>

      {/* Подвал */}
      <div className="text-[10px] text-gray-500 px-2 pb-4">
        Solvi: AI-powered personal skincare insights, cutting-edge analytical
        tools, and daily educational articles to keep you informed and glowing.
      </div>

      {/* CSS анимация */}
      <style>{`
        @keyframes pulsePink {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          50% {
            opacity: 0.5;
            transform: scale(1);
          }
          100% {
            opacity: 0;
            transform: scale(0.8);
          }
        }
        .animate-pulsePink {
          animation: pulsePink 3.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};
